/* TST Cart Drawer Upsell - Minimog native cart integration */
(() => {
  if (window.__tstCartUpsellLoaded) return;
  window.__tstCartUpsellLoaded = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const route = (path) => root.replace(/\/?$/, '/') + path;
  const boxSelector = '[data-tst-cart-upsell]';
  let generation = 0;
  let refreshPending = null;
  const escapeHTML = (value) => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const isValidId = (id) => Number.isSafeInteger(Number(id)) && Number(id) > 0;

  function formatMoney(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(Number(cents)/100); }
    catch (_) { return `${(Number(cents)/100).toFixed(2)} ${currency}`; }
  }

  async function getJSON(url, options) {
    const res = await fetch(url, {credentials:'same-origin', ...options});
    const data = await res.json();
    if (!res.ok || data.status >= 400) throw new Error(data.description || data.message || 'Request failed');
    return data;
  }

  function normalize(product) {
    if (!product) return null;
    const variants = Array.isArray(product.variants) ? product.variants.filter(v => v.available) : [];
    const variant = variants[0] || null;
    const variantId = (variant && variant.id) || product.variant_id;
    if (!isValidId(variantId)) return null;
    const image = product.image || product.featured_image || (product.images && product.images[0]) || '';
    const imageURL = typeof image === 'string' ? image : (image && (image.src || image.url)) || '';
    return {
      id: Number(product.id), variantId:Number(variantId),
      title:product.title || '', handle: product.handle || '', url:product.url || route('products/' + product.handle),
      image: (variant && (typeof variant.featured_image === 'string' ? variant.featured_image : (variant.featured_image && (variant.featured_image.src || variant.featured_image.url)) || '')) || imageURL,
      price: Number(variant ? variant.price : product.price) || 0,
      compare: Number(variant ? variant.compare_at_price : product.compare_at_price) || 0,
      variants: variants.map(v => ({
        id: Number(v.id), title: v.public_title || v.title || 'Default Title',
        price: Number(v.price) || 0, compare: Number(v.compare_at_price) || 0,
        image: typeof v.image === 'string' ? v.image : (v.image && (v.image.src || v.image.url)) || (typeof v.featured_image === 'string' ? v.featured_image : (v.featured_image && (v.featured_image.src || v.featured_image.url)) || '')
      }))
    };
  }

  // Product JSON is the authoritative source for actual Shopify variants.
  // Cached to avoid fetching again whenever the cart drawer refreshes.
  const productCache = new Map();
  async function fullProduct(product) {
    if (!product || !product.handle) return product;
    const handle = product.handle;
    if (!productCache.has(handle)) {
      const request = getJSON(route('products/' + encodeURIComponent(handle) + '.js'))
        .catch(error => {
          console.warn('[TST Cart Upsell] Variant lookup failed:', handle, error);
          productCache.delete(handle);
          return null;
        });
      productCache.set(handle, request);
    }
    const detail = await productCache.get(handle);
    if (!detail || !Array.isArray(detail.variants) || !detail.variants.length) return product;
    return {
      ...product,
      ...detail,
      // Prefer canonical product URL and product card image when supplied.
      url: product.url || route('products/' + handle),
      image: product.image || product.featured_image || detail.featured_image,
      variants: detail.variants
    };
  }

  function shuffle(list) {
    const a = list.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  // Source Size/Shape from the existing Nail Bundle block, without new Theme Settings.
  // These are line-item properties, not actual Shopify product variants.
  const FALLBACK_SIZE = ['XS','S','M','L'];
  const FALLBACK_SHAPE = ['Short Square','Short Oval','Short Almond','Medium Square','Medium Coffin','Medium Almond','Medium Stiletto','Long Coffin','Long Square','Long Almond','Long Stiletto'];
  let nailOptionPromise = null;

  function readBundleOptions(scope) {
    const bundle = scope.querySelector('[data-tst-nail-bundle]');
    if (!bundle) return null;
    const read = (name) => {
      const select = bundle.querySelector(`[data-tst-set-${name}]`);
      return select ? {
        values: [...select.options].map(option => option.value).filter(Boolean),
        selected: select.value
      } : null;
    };
    const size = read('size');
    const shape = read('shape');
    return size && shape && size.values.length && shape.values.length ? {size,shape} : null;
  }

  async function getNailOptions(referenceProduct) {
    if (!nailOptionPromise) {
      nailOptionPromise = (async () => {
        const local = readBundleOptions(document);
        if (local) return local;
        if (referenceProduct && referenceProduct.url) {
          try {
            const url = new URL(referenceProduct.url, location.origin);
            if (url.origin !== location.origin) throw new Error('External product URL');
            const response = await fetch(url.href, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Could not read Nail Bundle');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fromProduct = readBundleOptions(doc);
            if (fromProduct) return fromProduct;
          } catch (err) {
            console.warn('[TST Cart Upsell] Nail Bundle options unavailable:', err);
          }
        }
        return {
          size: { values: FALLBACK_SIZE, selected: 'XS' },
          shape: { values: FALLBACK_SHAPE, selected: 'Short Square' }
        };
      })();
    }
    return nailOptionPromise;
  }

  function nailSelectHTML(name, values, initial) {
    const attr = name === 'Size' ? 'size' : 'shape';
    return `<label class="tst-cart-upsell__nail-field"><span>${name}</span><select class="tst-cart-upsell__variant" data-tst-nail-${attr} aria-label="Choose nail ${name.toLowerCase()}">
      ${values.map(v => `<option value="${escapeHTML(v)}"${v === initial ? ' selected' : ''}>${escapeHTML(v)}</option>`).join('')}
    </select></label>`;
  }

  function cardHTML(product, showCompare, nailOptions) {
    const img = product.image ? `<img class="tst-cart-upsell__image" loading="lazy" draggable="false" src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}">` : '<div class="tst-cart-upsell__placeholder"></div>';
    const compare = showCompare && product.compare > product.price ? `<span class="tst-cart-upsell__compare">${escapeHTML(formatMoney(product.compare))}</span>` : '<span class="tst-cart-upsell__compare" hidden></span>';
    const variants = product.variants || [];
    const hasVariants = variants.length > 1 || (variants.length === 1 && !['Default Title', 'Default'].includes(variants[0].title));
    const select = hasVariants ? `<label class="tst-cart-upsell__nail-field"><span>Variant</span><select class="tst-cart-upsell__variant" data-tst-variant aria-label="Choose variant for ${escapeHTML(product.title)}">${variants.map(v => `<option value="${v.id}" data-price="${v.price}" data-compare="${v.compare}" data-image="${escapeHTML(v.image)}">${escapeHTML(v.title)}</option>`).join('')}</select></label>` : '';
    const nailFields = nailOptions ? `<div class="tst-cart-upsell__nail-fields">
      ${nailSelectHTML('Size', nailOptions.size.values, nailOptions.size.selected)}
      ${nailSelectHTML('Shape', nailOptions.shape.values, nailOptions.shape.selected)}
    </div>` : '';
    return `<article class="tst-cart-upsell__card" data-show-compare="${showCompare}">
      <div class="tst-cart-upsell__card-top">${img}
        <div class="tst-cart-upsell__side">${compare}<strong class="tst-cart-upsell__price">${escapeHTML(formatMoney(product.price))}</strong>
          <button type="button" class="tst-cart-upsell__add" data-upsell-add="${product.variantId}" aria-label="Add ${escapeHTML(product.title)} to cart">+</button>
        </div>
      </div>
      <a class="tst-cart-upsell__name" href="${escapeHTML(product.url)}" draggable="false">${escapeHTML(product.title)}</a>
      ${select}
      ${nailFields}
    </article>`;
  }

  function changeVariant(select) {
    const card = select.closest('.tst-cart-upsell__card');
    if (!card) return;
    const option = select.selectedOptions[0];
    const button = card.querySelector('[data-upsell-add]');
    if (!option || !button) return;
    button.dataset.upsellAdd = option.value;
    const price = Number(option.dataset.price) || 0;
    const comparePrice = Number(option.dataset.compare) || 0;
    card.querySelector('.tst-cart-upsell__price').textContent = formatMoney(price);
    const compare = card.querySelector('.tst-cart-upsell__compare');
    if (compare) {
      compare.hidden = card.dataset.showCompare !== 'true' || comparePrice <= price;
      compare.textContent = !compare.hidden ? formatMoney(comparePrice) : '';
    }
    const variantImage = option.dataset.image;
    const img = card.querySelector('.tst-cart-upsell__image');
    if (variantImage && img) img.src = variantImage;
  }

  async function loadRecommendations(cart, limit) {
    const ids = Array.from(new Set(cart.items.map(i => i.product_id).filter(isValidId))).slice(0, 3);
    const promises = ids.map(id => getJSON(route(`recommendations/products.json?product_id=${id}&limit=10&intent=related`)).then(data => data.products || []).catch(() => []));
    const arrays = await Promise.all(promises);
    const unique = new Map();
    arrays.forEach(products => products.forEach(p => {
      if (!unique.has(String(p.id))) unique.set(String(p.id), p);
    }));
    return shuffle(Array.from(unique.values())).slice(0, Math.max(limit * 3, 10));
  }

  async function loadCollectionProducts(collectionHandle) {
    if (!collectionHandle) return [];
    const result = await getJSON(route(`collections/${encodeURIComponent(collectionHandle)}/products.json?limit=50`));
    return result.products || [];
  }

  async function render() {
    const box = document.querySelector(boxSelector);
    if (!box) return;
    const gen = ++generation;
    if (box.dataset.enabled !== 'true') { box.hidden = true; return; }
    const limit = Math.max(1, Math.min(10, Number(box.dataset.count) || 6));
    try {
      const cart = await getJSON(route('cart.js'));
      if (gen !== generation) return;
      if (!cart.items || !cart.items.length) {box.hidden = true; return;}
      const excluded = new Set(cart.items.map(item => String(item.product_id)));
      const source = box.dataset.source;
      let products;
      if (source === 'related') {
        products = await loadRecommendations(cart, limit);
      } else {
        try {products = JSON.parse(box.querySelector('[data-tst-pool]').textContent);} catch (_) {products=[];}
        if (source === 'random') products = shuffle(products);
      }
      if (gen !== generation) return;
      const unique = new Set();
      const candidates = products.map(normalize).filter(p => {
        if (!p || excluded.has(String(p.id)) || unique.has(String(p.id))) return false;
        unique.add(String(p.id));
        return true;
      }).slice(0, limit);
      if (!candidates.length) {box.hidden = true; return;}
      const resolved = await Promise.all(candidates.map(fullProduct));
      if (gen !== generation) return;
      const visible = resolved.map(normalize).filter(Boolean);
      if (!visible.length) {box.hidden = true; return;}
      // Existing collection selector is the Nail filter; no second collection setting.
      const nailOptions = source === 'collection' ? await getNailOptions(visible[0]) : null;
      if (gen !== generation) return;
      const track = box.querySelector('[data-tst-track]');
      const viewport = box.querySelector('[data-tst-viewport]');
      const previousScroll = viewport.scrollLeft;
      setupDrag(viewport);
      track.innerHTML = visible.map(p => cardHTML(p, box.dataset.showCompare === 'true', nailOptions)).join('');
      box.hidden = false;
      viewport.scrollLeft = previousScroll;
      box.querySelector('[data-tst-error]').hidden = true;
    } catch (error) {
      console.warn('[TST Cart Upsell]', error);
      box.hidden = true;
    }
  }

  function scheduleRender() {
    if (refreshPending) clearTimeout(refreshPending);
    refreshPending = setTimeout(() => { refreshPending = null; render(); }, 100);
  }

  async function addProduct(button) {
    const select = button.closest('.tst-cart-upsell__card')?.querySelector('[data-tst-variant]');
    const id = Number(select ? select.value : button.dataset.upsellAdd);
    const box = button.closest(boxSelector);
    if (!isValidId(id) || !box || box.dataset.adding === 'true') return;
    box.dataset.adding = 'true';
    button.disabled = true;
    button.textContent = '…';
    const card = button.closest('.tst-cart-upsell__card');
    const nailSize = card?.querySelector('[data-tst-nail-size]')?.value;
    const nailShape = card?.querySelector('[data-tst-nail-shape]')?.value;
    const properties = nailSize && nailShape ? { Size: nailSize, Shape: nailShape } : null;
    const errorEl = box.querySelector('[data-tst-error]');
    errorEl.hidden = true;
    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {bubbles:true,detail:{sections}}));
      const required = ['cart-drawer', 'cart-count'];
      required.forEach(s => {if (!sections.includes(s)) sections.push(s);});
      const item = {id,quantity:1};
      if (properties) item.properties = properties;
      const payload = {items:[item], sections, sections_url:location.pathname};
      const added = await getJSON(route('cart/add.js'), {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify(payload)
      });
      const validSections = added.sections && added.sections['cart-drawer'] && added.sections['cart-count'];
      if (validSections && window.MinimogEvents && window.MinimogTheme) {
        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {cart:added,productVariantId:id});
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
      }
      const drawer = document.querySelector('m-cart-drawer');
      if (drawer && window.MinimogSettings && MinimogSettings.enable_cart_drawer) drawer.open();
      document.dispatchEvent(new CustomEvent('product-ajax:added',{detail:{product:added}}));
      scheduleRender();
    } catch (err) {
      errorEl.textContent = err.message || 'Could not add this product.';
      errorEl.hidden = false;
    } finally {
      box.dataset.adding = 'false';
      if (button.isConnected) {button.disabled = false;button.textContent = '+';}
    }
  }

  // Smooth mouse drag with pointer capture. Touch uses native momentum scrolling.
  function setupDrag(viewport) {
    if (!viewport || viewport.dataset.dragReady === 'true') return;
    viewport.dataset.dragReady = 'true';
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startScroll = 0;
    let dragged = false;
    let suppressNextClick = false;
    const threshold = 5;

    // Prevent native drag of images/links from competing with slider dragging.
    viewport.addEventListener('dragstart', e => e.preventDefault());

    viewport.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, select, option, input, textarea')) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      startScroll = viewport.scrollLeft;
      dragged = false;
      suppressNextClick = false;
      // Pointer capture keeps movements coming even outside the small slider.
      try { viewport.setPointerCapture(pointerId); } catch (_) {}
    });

    viewport.addEventListener('pointermove', e => {
      if (pointerId !== e.pointerId) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      if (!dragged && Math.abs(dx) < threshold) return;
      if (!dragged && Math.abs(dy) > Math.abs(dx) * 1.5) return;
      dragged = true;
      viewport.classList.add('is-dragging');
      // The scroll position is tied to the initial position, not accumulated per frame.
      viewport.scrollLeft = startScroll - dx;
      if (e.cancelable) e.preventDefault();
    }, { passive: false });

    const finish = e => {
      if (pointerId === null || (e && e.pointerId !== pointerId)) return;
      if (dragged) suppressNextClick = true;
      const held = pointerId;
      pointerId = null;
      dragged = false;
      viewport.classList.remove('is-dragging');
      try { if (viewport.hasPointerCapture(held)) viewport.releasePointerCapture(held); } catch (_) {}
    };
    viewport.addEventListener('pointerup', finish);
    viewport.addEventListener('pointercancel', finish);
    viewport.addEventListener('lostpointercapture', finish);
    // Do not cancel pointerleave: pointer capture allows continuous dragging.
    viewport.addEventListener('click', e => {
      if (!suppressNextClick) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      suppressNextClick = false;
    }, true);
  }

  document.addEventListener('change', event => {
    const select = event.target.closest('[data-tst-cart-upsell] [data-tst-variant]');
    if (select) changeVariant(select);
  });

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-tst-cart-upsell] [data-upsell-add]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    addProduct(button);
  });
  document.addEventListener('cart:updated', scheduleRender);
  document.addEventListener('cart:refresh', scheduleRender);
  document.addEventListener('shopify:section:load', scheduleRender);
  function start() {
    const box = document.querySelector(boxSelector);
    if (!box) return;
    const viewport = box.querySelector('[data-tst-viewport]');
    if (viewport) setupDrag(viewport);
    render();
    if (window.MinimogEvents && window.MinimogTheme && !window.__tstCartUpsellSubscribed) {
      window.__tstCartUpsellSubscribed = true;
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, scheduleRender);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
